<script setup lang="ts">
import { AppFlicker } from '@libs/ui';

import { HotelSelectionCardState } from '../models';

import HotelSelectionCardLayout from './HotelSelectionCardLayout.vue';
</script>

<template>
  <HotelSelectionCardLayout
    class="hotel-selection-card-loader"
    :card-state="HotelSelectionCardState.None"
  >
    <template #image>
      <div class="image-loader" />
    </template>
    <template #content>
      <div class="content-loader">
        <div class="top">
          <AppFlicker width="spacing-96" height="spacing-12" />
          <AppFlicker width="spacing-48" height="spacing-12" />
        </div>
        <div class="bottom">
          <AppFlicker width="spacing-96" height="spacing-12" />
        </div>
      </div>
    </template>
    <template #summary>
      <div class="summary-loader">
        <AppFlicker
          width="spacing-80"
          height="spacing-16"
          border-radius="border-radius-20"
        />
      </div>
    </template>
  </HotelSelectionCardLayout>
</template>

<style scoped lang="scss">
.hotel-selection-card-loader {
  &:first-of-type {
    margin-top: var(--spacing-16);
    @include for-more-or-equal-than-1535-px {
      margin-top: 0;
    }
    @include for-less-or-equal-than-1199-px {
      margin-top: 0;
    }
  }
  .image-loader {
    background-color: var(--color-neutral-30);
    width: 100%;
    height: 100%;
  }

  .content-loader {
    height: 100%;
    padding: var(--spacing-16);

    background-color: var(--color-white);

    display: flex;
    flex-direction: column;
    justify-content: space-between;

    .top {
      display: flex;
      flex-direction: column;
      gap: var(--spacing-8);
    }

    .bottom {
      display: flex;
      justify-content: space-between;
      align-items: center;
    }
  }

  .summary-loader {
    height: 100%;
    display: flex;
    align-items: flex-end;
    justify-content: flex-end;
  }
}
</style>
